var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect3, _rect4, _rect5, _rect6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForutsigbarBetaling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 201,
    viewBox: "0 0 254 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6187 85.0811C12.6187 82.8719 14.4095 81.0811 16.6187 81.0811H24.0627C26.2719 81.0811 28.0627 82.8719 28.0627 85.0811V196.001C28.0627 198.21 26.2719 200.001 24.0627 200.001H16.6187C14.4095 200.001 12.6187 198.21 12.6187 196.001V85.0811Z",
    fill: "#E3E4FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.7156,
    y: 138.996,
    width: 15.4441,
    height: 61.0042,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.426,
    y: 138.996,
    width: 15.4441,
    height: 61.0042,
    rx: 4,
    fill: "#E3E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7502 118.146H102.194V196C102.194 198.209 100.403 200 98.1943 200H90.7502C88.5411 200 86.7502 198.209 86.7502 196V118.146Z",
    fill: "#E3E4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.461 122.78H126.905V196C126.905 198.209 125.114 200 122.905 200H115.461C113.252 200 111.461 198.209 111.461 196V122.78Z",
    fill: "#E3E4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.171 153.668H151.615V196C151.615 198.209 149.825 200 147.615 200H140.171C137.962 200 136.171 198.209 136.171 196V153.668Z",
    fill: "#E3E4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.882 111.336C160.882 109.127 162.673 107.336 164.882 107.336H172.326C174.535 107.336 176.326 109.127 176.326 111.336V196.001C176.326 198.21 174.535 200.001 172.326 200.001H164.882C162.673 200.001 160.882 198.21 160.882 196.001V111.336Z",
    fill: "#E3E4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.593 111.336C185.593 109.127 187.383 107.336 189.593 107.336H197.037C199.246 107.336 201.037 109.127 201.037 111.336V196.001C201.037 198.21 199.246 200.001 197.037 200.001H189.593C187.383 200.001 185.593 198.21 185.593 196.001V111.336Z",
    fill: "#E3E4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.303 111.336C210.303 109.127 212.094 107.336 214.303 107.336H221.747C223.956 107.336 225.747 109.127 225.747 111.336V196.001C225.747 198.21 223.956 200.001 221.747 200.001H214.303C212.094 200.001 210.303 198.21 210.303 196.001V111.336Z",
    fill: "#E3E4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7498 111.337C86.7498 109.128 88.5406 107.337 90.7498 107.337H98.1938C100.403 107.337 102.194 109.128 102.194 111.337V118.148H86.7498V111.337Z",
    fill: "#2D0067"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7148 111.337C37.7148 109.128 39.5057 107.337 41.7148 107.337H49.1589C51.3681 107.337 53.1589 109.128 53.1589 111.337V146.72H37.7148V111.337Z",
    fill: "#2D0067"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4255 111.337C62.4255 109.128 64.2164 107.337 66.4255 107.337H73.8696C76.0788 107.337 77.8696 109.128 77.8696 111.337V161.391H62.4255V111.337Z",
    fill: "#2D0067"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.46 111.337C111.46 109.128 113.251 107.337 115.46 107.337H122.905C125.114 107.337 126.905 109.128 126.905 111.337V122.781H111.46V111.337Z",
    fill: "#2D0067"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136.171,
    y: 107.337,
    width: 15.4441,
    height: 92.6645,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160.881,
    y: 107.337,
    width: 15.4441,
    height: 92.6645,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185.592,
    y: 107.337,
    width: 15.4441,
    height: 92.6645,
    rx: 4,
    fill: "#E3E4FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210.302,
    y: 107.337,
    width: 15.4441,
    height: 92.6645,
    rx: 4,
    fill: "#E3E4FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19434 103.089L235.014 103.089",
    stroke: "#2D0067",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.9 91.3923L192.395 100.47L215.305 68.9377C216.603 67.1505 216.207 64.649 214.42 63.3505L208.397 58.975C206.61 57.6765 204.109 58.0727 202.81 59.8599L179.9 91.3923Z",
    fill: "#E3E4FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.698 93.7632L171.335 101.014L182.786 79.4774C183.823 77.5269 183.082 75.1049 181.132 74.0678L174.559 70.573C172.608 69.5358 170.186 70.2763 169.149 72.2269L157.698 93.7632Z",
    fill: "#E3E4FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.559 94.0637L150.667 100.345L155.852 88.6997C156.751 86.6815 155.843 84.3171 153.825 83.4186L147.025 80.3908C145.007 79.4922 142.642 80.3999 141.744 82.418L136.559 94.0637Z",
    fill: "#E3E4FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.076 57.1462L122.989 66.9753L126.022 63.299C127.428 61.595 127.186 59.0739 125.482 57.6679L119.741 52.9303C118.037 51.5243 115.515 51.7659 114.11 53.4699L111.076 57.1462Z",
    fill: "#E3E4FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.799 90.1489L216.629 100.076L251.235 58.8351C252.655 57.1428 252.434 54.6198 250.742 53.1998L245.039 48.4148C243.347 46.9948 240.824 47.2155 239.404 48.9078L204.799 90.1489Z",
    fill: "#E3E4FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0237 63.1735C22.562 62.6898 22.1721 60.8053 23.3217 59.7813L37.9139 46.7843C39.0636 45.7603 40.8907 46.3649 41.2027 47.8725L45.1623 67.0082C45.4742 68.5159 44.0371 69.7959 42.5755 69.3122L24.0237 63.1735Z",
    fill: "#FFEFE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2837 48.0308C76.2837 52.806 72.4127 56.677 67.6375 56.677C62.8623 56.677 58.9912 52.806 58.9912 48.0308C58.9912 43.2556 62.8623 39.3845 67.6375 39.3845C72.4127 39.3845 76.2837 43.2556 76.2837 48.0308Z",
    fill: "#2D0067"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2677 75.0996L91.8869 85.4454L95.2646 82.2885L102.531 90.0631L97.4513 94.8105C94.5287 97.5421 90.0352 97.6879 86.9416 95.1516L79.1958 88.8014L67.6428 98.0721L60.9827 89.7724L79.2677 75.0996Z",
    fill: "#2D0067"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1599 69.5952L97.5938 51.7405L100.074 57.9119L55.6397 75.7666L53.1599 69.5952Z",
    fill: "#2D0067"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3762 6.25511C90.8794 5.42728 92.1479 5.72689 92.2274 6.69234L92.856 14.3202C92.8916 14.7519 93.2011 15.1117 93.6228 15.2113L101.072 16.9706C102.014 17.1933 102.121 18.4923 101.228 18.8663L94.1675 21.8212C93.7679 21.9885 93.5214 22.3941 93.5569 22.8258L94.1855 30.4537C94.2651 31.4191 93.0628 31.9223 92.4309 31.188L87.4388 25.3865C87.1563 25.0581 86.6944 24.949 86.2947 25.1162L79.2345 28.0712C78.3409 28.4452 77.4907 27.4572 77.9938 26.6294L81.9688 20.0888C82.1938 19.7186 82.1548 19.2456 81.8723 18.9172L76.8802 13.1157C76.2484 12.3814 76.9253 11.2675 77.8681 11.4902L85.3168 13.2495C85.7385 13.3491 86.1763 13.1659 86.4013 12.7956L90.3762 6.25511Z",
    fill: "#B8FFEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.975 83.6633C107.558 84.7487 110.984 84.1618 113.884 81.8586C115.411 80.6466 117.015 77.1295 117.178 74.7",
    stroke: "#2D0067",
    strokeWidth: 1.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.469 80.4324C106.979 81.4353 111.128 79.3771 112.283 76.4865C112.77 75.2684 113.214 73.1164 112.568 69.5317",
    stroke: "#2D0067",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForutsigbarBetaling);
export default __webpack_public_path__ + "static/media/Forutsigbar Betaling.be73a36ea5fc69c12d79d601b58d6636.svg";
export { ForwardRef as ReactComponent };